import { Constants } from 'crono-fe-common/constants/constants';
import { LanguageOption } from 'crono-fe-common/types/languageOption';
import { mapLanguageToLabel } from 'utils/formatUtils';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@crono-one/design-system';

interface LanguagePickerProps {
  language: LanguageOption;
  onLanguageChange: (language: LanguageOption) => void;
  hideOptionAll?: boolean;
  size?: 'xs' | 'sm' | 'md';
  triggerClassName?: string;
  contentClassName?: string;
  triggerId?: string;
}

const LanguagePicker = ({
  language,
  onLanguageChange,
  hideOptionAll = true,
  size,
  triggerClassName,
  contentClassName,
  triggerId,
}: LanguagePickerProps) => {
  const languages = hideOptionAll
    ? Constants.templateLanguagesInput
    : Constants.templateLanguages;

  return (
    <Select value={language} onValueChange={(value) => onLanguageChange(value)}>
      <SelectTrigger size={size} className={triggerClassName} id={triggerId}>
        <SelectValue placeholder="Select language" />
      </SelectTrigger>

      <SelectContent className={contentClassName}>
        <SelectGroup>
          {languages.map((languageOption) => (
            <SelectItem value={languageOption} key={languageOption}>
              {mapLanguageToLabel(languageOption)}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default LanguagePicker;
